import { toast, Toast as ToastType } from 'react-hot-toast'
import ErrorToast from 'components/toasts/ErrorToast'
import * as Sentry from '@sentry/nextjs'
import { CustomError } from 'api/customError'
import usePush from 'hooks/usePush'

enum ErrorMessage {
  Collision = 'already opted in to app'
}

const getErrorMessage = (error: unknown) => {
  if (error instanceof Error || error instanceof CustomError) {
    if (error.message.includes(ErrorMessage.Collision)) {
      return 'This NFD has already been minted.'
    } else {
      return error.message
    }
  }

  return null
}

type HandleErrorOptions = {
  errorMessage?: string
  redirect?: string
} & Partial<ToastType>

export default function useErrorToast(fallbackMessage?: string, duration = Infinity) {
  const push = usePush()

  return (error: unknown, options?: HandleErrorOptions) => {
    const errorMessage =
      getErrorMessage(error) || options?.errorMessage || fallbackMessage || JSON.stringify(error)

    console.error(error)
    Sentry.captureException(error)

    if (options?.redirect) {
      push(options.redirect)
    }

    toast.error(
      (t) => {
        return ErrorToast({
          error: errorMessage,
          t
        })
      },
      { duration, ...options }
    )
  }
}
